import pendoBaseStyles from './pendo-global';

const PendoGlobalStyleSheet = `
${pendoBaseStyles}
`;
export default PendoGlobalStyleSheet;
